import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconCancel from "components/IconComponent/IconCancel";
import { useResponsivePixel } from "pages/manager-meeting/components/useResponsivePixel";

const ButtonCancelIcon = ({onClick}) => {
    const {t} = useTranslation();
    const { mdPixel } = useResponsivePixel();

    return (
        <Button
            className="button-header"
            variant="outlined"
            size="small"
            style={{ marginRight: '16px' }}
            startIcon={<IconCancel width={mdPixel ? 14 : 20} height={mdPixel ? 14 : 20}/>}
            onClick={() => {
                onClick();
            }}
        >
            <Box sx={{ display: { xs: 'none', md: 'flex' } }} style={{ fontWeight: '700' }}>
                {t('room.cancel')}
            </Box>
        </Button>
    )
}

export default ButtonCancelIcon
